module.exports = __webpack_public_path__ + "assets/img/map.3acd1c96.png";